import styled from 'styled-components';

export const HeroContainer = styled.div`
  width: 100%;
  height: 700px;
  padding-top: 100px;
  display: flex;
  /* border: 1px solid red; */
`;

export const HeroContent = styled.div`
 /* border: 1px solid red; */
 /* text-align: center; Align text horizontally */
  /* If you want to center text vertically as well, you can use flexbox */
  justify-content: center; 
  align-items: center; 
  padding-right: 2%;
  padding-left: 4%;
  /* display: flex; */
  width: 60%;
  padding-top:17%;
  /* border: 1px solid red; */

`;

export const HeroHeader = styled.div`

  font-size: 2.5rem; /* Adjust font size as needed */
  font-weight: bold; /* Adjust font weight as needed */
  margin-bottom: 20px; /* Adjust margin as needed */
  /* margin: 10%; */
  text-align: left;
  /* margin-left: 6%; */
  color: #3d780d;
  /* border: 1px solid red; */
`;

export const HeroText = styled.p`

  font-size: 1rem; /* Adjust font size as needed */
  color: #333; /* Adjust text color as needed */
  line-height: 1.5; /* Adjust line height as needed */
  margin-bottom: 15px; /* Adjust margin as needed */
  /* margin-left: 10%; */
  /* padding-right: 7%; */
  /* margin-right: 10%; */
  text-align: left;
  /* border: 1px solid red; */
  font-size: 1.2em;
text-align: justify;


 
`;

export const HeroSlider = styled.div`
  font-size: 2.5rem; /* Adjust font size as needed */
  font-weight: bold; /* Adjust font weight as needed */

  margin-bottom: 20px; /* Adjust margin as needed */
  /* margin: 10%; */
  text-align: left;
  margin-left: 5%;
  color: #3d780d;
  /* border: 5px solid red; */
`

export const SliderContainer = styled.div`
 /* border: 1px solid red; */

  position: relative;
  width: 40%;
  /* max-width: 500px; */
  /* height: auto; */
  /* margin: 0 auto; */
  overflow: hidden;

  justify-content: center; 
  align-items: center; /* Align items vertically */
  display: flex;
  padding-right: 5%;
  /* margin-right: 10%; */
  /* border: 1px solid red; */
  padding-bottom: 3%;
`;

export const Slide = styled.img`
  position: absolute;
  /* top: 0; */
  /* left: 0; */
  /* width: 100%; */
  /* height: auto; */
  opacity: ${props => props.active ? 1 : 0};
  transition: opacity 0.5s ease;
  padding-top: 40px;
  padding-left: 60px;
  /* border: 1px solid red; */
`;

export const SectionOne = styled.div`
  width: 100%;
  height: 1050px;
  padding-top: 100px;
  display: columns;
  /* padding-left: 4%; */
  /* padding: 10%; */
  /* margin: 10%; */
  /* border: 1px solid red; */
  background-color: rgba(124, 197, 41, 0.1);
  /* border: 1px solid red; */
`;

export const SectionOneHeader = styled.div`
  font-size: 2.5rem; /* Adjust font size as needed */
  font-weight: bold; /* Adjust font weight as needed */
  /* margin-bottom: 20px;  */
  /* margin: 10%; */
  text-align: left;
  margin-left: 10%;
  margin-bottom: 3%;
  color: #1D2C42;
  /* border: 1px solid red; */
;
`

export const ProgramText = styled.p`

  font-size: 1rem; /* Adjust font size as needed */
  color: #333; /* Adjust text color as needed */
  line-height: 1.5; /* Adjust line height as needed */
  margin-bottom: 15px; /* Adjust margin as needed */
  /* margin-left: 10%; */
  padding-right: 7%;
  padding-left: 7%;
  /* margin-right: 10%; */
  text-align: left;
  /* border: 1px solid red; */
  font-size: 1.2em;
text-align: justify;


 
`;

export const SectionOnePrograms = styled.div`
  /* font-size: 2.5rem; Adjust font size as needed */
  /* font-weight: bold; Adjust font weight as needed */
  /* margin-bottom: 20px;  */
  /* margin: 10%; */
  /* text-align: left; */
  /* border: 1px solid red; */
/* width: 100%; */
/* padding: 0% 0% 0% 10%; */
align-content: center;
justify-content: center;
margin-top: 4%;
margin-bottom: 1%;
display: flex;
/* border: 1px dotted red; */
margin-left: 4%;

;
`



export const SectionTwo = styled.div`
  width: 100%;
  height: 120%;
  padding-top: 6%;
  padding-bottom: 4%;
  display: flex;
text-align: justify;
  /* border: 1px solid red; */


  
`;



export const SectionTwoPicture = styled.div`
  /* border: 1px solid red; */
 margin-left: 6%;
`;

export const SectionTwoPictureTitle = styled.div`

  font-size: 1.5rem; /* Adjust font size as needed */
  font-weight: bold; /* Adjust font weight as needed */
  /* margin-bottom: 20px; Adjust margin as needed */
  /* margin: 10%; */
  text-align: center;
  /* margin-left: 10%; */
  color: #3d780d;
  /* border: 1px solid red; */
`;


export const SectionTwoContent = styled.div`
 
  display: columns;

  margin-left: 5%;
 margin-right: 5%;
 /* font-size: 10rem; */
`;

export const SectionTwoHeader = styled.div`
 
 font-size: 2.5rem; /* Adjust font size as needed */
  font-weight: bold; /* Adjust font weight as needed */
  /* margin-bottom: 20px;  */
  /* margin: 10%; */
  text-align: left;
  /* margin-left: 10%; */
  color: #1D2C42;
  /* border: 1px solid red; */
  margin-bottom: 6%;
;
`;

export const SectionTwoParagraph = styled.span`
font-weight: bold;
color: #3d780d;
`
 

export const SectionTwoText = styled.div`
 
  display: columns;
  /* border: 1px solid red; */
  /* font-size: 16px; */
  line-height: 1.5;
  color: #333;
  /* border: 1px solid red; */
   font-size: 1.2rem;
  
`;




export const SectionThree = styled.div`
  width: 100%;
  height: 580px;
  padding-top: 100px;
  display: columns;
  /* border: 1px solid red; */
  background-color: rgba(124, 197, 41, 0.3);
`;


export const SectionThreeVison = styled.div`

  /* display: column; */
  /* border: 4px solid yellow; */
  margin-left: 10%; 
  margin-right: 5%;
  /* margin-left: 2% */
  /* background-color: rgba(124, 197, 41, 0.3); */
`;

export const SectionThreeVisonHeader = styled.div`
  font-size: 2.5rem; /* Adjust font size as needed */
  font-weight: bold; /* Adjust font weight as needed */
  /* margin-bottom: 20px;  */
  /* margin: 10%; */
  /* text-align: left; */
  /* margin-left: 10%; */
  margin-bottom: 2%;
  /* border: 8px solid blue; */
  color: #1D2C42;
  /* border: 1px solid red; */

`;

export const SectionThreeVisonText = styled.div`

font-size: 2rem; /* Adjust font size as needed */
  font-weight: bold; /* Adjust font weight as needed */
  /* margin-bottom: 20px; Adjust margin as needed */
  /* margin: 10%; */
  /* text-align: left; */
  /* margin-left: 10%; */
  color: #3d780d;
  /* border: 1px solid red; */
  text-align: justify;
`;

export const SectionThreeWrapper = styled.div`

 display: flex;
 margin-left: 10%;
 margin-top: 5%;
 margin-right: 5%;

`;

export const SectionThreeMission = styled.div`
/* margin-left: 10%; */ 
/* border: 10px dotted red; */
width: 100%;
margin-right: 5%;
font-size: 1.2em;
text-align: justify;
`;

export const SectionThreeGoal = styled.div`
/* margin-right: 50%; */
font-size: 1.2em;
text-align: justify;

`;

export const SectionThreeMissionText = styled.div`
/* margin-left: 50%; */
`;

export const SectionThreeGoalText = styled.div`
/* margin-left: 50%; */
`;

export const SectionFour = styled.div`
  width: 100%;
  height: 350px;
  padding-top: 100px;
  display: flex;
  /* border: 1px solid red; */
  /* margin-left: 10%; */
`;

export const ContactWrapper = styled.div`
  /* width: 100%; */
  /* height: 680px; */
  /* padding-top: 100px; */
  width: 100%;
  display: columns;
  /* border: 1px solid red; */
  
`;

export const ContactHeader = styled.div`
 font-size: 2.5rem; /* Adjust font size as needed */
  font-weight: bold; /* Adjust font weight as needed */
  /* margin-bottom: 20px;  */
  /* margin: 10%; */
  text-align: left;
  margin-left: 10%;
  color: #1D2C42;
  /* border: 1px solid red; */
`;



export const SectionFive = styled.div`
  width: 100%;
  height: 60px;
  /* padding-top: 100px; */
  display: flex;
  /* border: 1px solid red; */
  background-color: rgba(124, 197, 41);
  text-align: center;
  justify-content: center;

`;

export const SectionFivecontent = styled.div`
  width: 100%;
  
  text-align: center;
  justify-content: center;
  display: flex;
  margin-top: 4%;
  /* border: 1px solid red; */
`;

export const SectionFiveMiniHead = styled.div`
  font-size: 1.5rem; /* Adjust font size as needed */
  font-weight: bold; /* Adjust font weight as needed */
  color: #3d780d;
  /* border: 1px solid red; */
`
export const SectionFiveMiniContent = styled.div`
  /* display: columns; */
  /* border: 1px solid red; */
  /* font-size: 16px; */
  /* line-height: 1.5; */
  color: #333;
  /* width: 50%; */
  /* border: 1px solid red; */
   font-size: 1.2rem;
   
`

export const SectionFiveAddress = styled.div`
/* border: 1px solid red; */
margin-right: 10%;
margin-left: 10%;
`;

export const SectionFiveEmail = styled.div`
margin-right: 10%;

`;

export const SectionFiveNumber = styled.div`
margin-right: 10%;

`;




export const FooterText = styled.div`
margin-top: 1.2%;
`

